const setUrlToHC = (url: string) => {
  const checkUrlIsHC = window.location.href.includes("://hc-");
  const splitUrl = url.split("//");
  return checkUrlIsHC ? `${splitUrl[0]}//hc-${splitUrl[1]}` : url;
};

export const NODE_ENV = process.env.NODE_ENV || "development";
export const BASE_URL = setUrlToHC(process.env.REACT_APP_BASE_URL || "");
export const MIDDLE_URL = "/bb-one/fi/simple";
export const GCS_URL = setUrlToHC(process.env.REACT_APP_GCS_URL || "");
export const GCS_BUCKET_NAME = process.env.REACT_APP_GCS_BUCKET_NAME || "";

export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID || "";
export const CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET || "";
export const DASHBOARD_URL = setUrlToHC(process.env.REACT_APP_DASHBOARD_URL || "");
export const BBAUTH_URL = process.env.REACT_APP_BBAUTH_URL || "";
export const APP_ID = process.env.REACT_APP_APP_ID || 99;
